import React, { useEffect,useState,createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import ArticleModalWithDatatable from '../article/ArticleModalWithDatatable';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import * as RestService from '../../services/eisRest';





  const BomModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = useState(false);
    const [month, setMonth] = useState(null);  
    const [selectedRecord, setSelectedRecord] = useState();
    const [entityId, setEntityId] = useState();
    const [bom, setBom] = useState([]);  
    const [openAlertDialog, setOpenAlertDialog] = useState(false);    
    const dialogRef = createRef();
    const [showArticleModalWithDatatable, setShowArticleModalWithDatatable] = useState(false);
    const [loadedArticle, setLoadedArticle] = useState();

    const handleOpenArticleList = () => {
      setShowArticleModalWithDatatable(true);
    }

    const handleCallback = (show,id) => {         
      setShowArticleModalWithDatatable(show);             
      getDataAboutArticle(id);
    };
  
    const getDataAboutArticle = (id) => {
      RestService.callAnyApi('article/getArticle?id='+id, null)
      .then((data) => {
        setLoadedArticle(data);       
        formik.setFieldValue("articleName",data.name);
      })
      .catch((error) => {
        console.log(error);
      });
    }

    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    
    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('workOrder/getBom?id='+props.selectedRecord, null)
      .then((data) => {          
           setBom(data);    
           getDataAboutArticle(data.articleId);
      })
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  
    useEffect(() => {      
      setEntityId(props.entityId);
    }, [props.entityId])

   

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=bom&id='+props.selectedRecord, null).then(
          (data) => {
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      
    }
    

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
         
  //    bom.entityId=props.entityId;
    //  bom.bankId=values.bankId;
    //  bom.currency=values.currency;
    //  bom.departmentId=values.departmentId;
     // bom.iban=values.iban;
      bom.articleId = loadedArticle.id;
      bom.name = values.name;
      bom.description = values.description;
      
     
      RestService.callAnyApi(url, bom)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
       
        name: bom ? bom.name : '',
        description: bom ? bom.description : ''
      },
      validationSchema: Yup.object({
         name: Yup.string()     
          .nullable()
          .required(t('general.message.required')),
          articleName: Yup.string()     
           .nullable()
          .required(t('general.message.required')),
       //   currency: Yup.string()     
       //   .required(t('general.message.required')),
        //  iban: Yup.string()     
         // .required(t('general.message.required')),
      }),
      onSubmit: (values) => {           
          save('workOrder/saveBom',values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                    ref={dialogRef}
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('workOrder.label.bom')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                
                          <div className="row"> 
                                <div className="col-12 col-sm-12 col-lg-12">
                                  <div className="form-group">
                                    <label>{t('workOrder.label.articleName')}</label>
                                    <input type="text" class="form-control" readOnly onClick={handleOpenArticleList} placeholder="" {...formik.getFieldProps('articleName')} />
                                  </div>
                                  {formik.touched.articleName && formik.errors.articleName ? (
                                    <div style={{ color: 'red' }}>{formik.errors.articleName}</div>
                                ) : null} 
                                </div>        
                          </div>

                          <div className="row"> 
                                <div className="col-6 col-sm-6 col-lg-6">
                                  <div className="form-group">
                                    <label>{t('workOrder.label.bomName')}</label>
                                    <input type="text" class="form-control"  {...formik.getFieldProps('name')} />
                                  </div>
                                  {formik.touched.name && formik.errors.name ? (
                                    <div style={{ color: 'red' }}>{formik.errors.name}</div>
                                ) : null} 
                                </div>        
                          </div>
                     

                          <div className="row">

                              <div className="col-12 col-sm-12 col-lg-12">
                                  <div className="form-group">
                                      <label>{t('general.label.description')}</label>
                                      <input type="text" class="form-control" placeholder={t('general.label.description')} {...formik.getFieldProps('description')} />
                                  </div>
                                  {formik.touched.description && formik.errors.description ? (<div style={{ color: 'red' }}>{formik.errors.description}</div>) : null} 
                              </div>

                          </div>
                           

                    </Modal.Body>
                    <Modal.Footer>      
                          <Button style={selectedRecord ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>                                            
                          <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 

                <ArticleModalWithDatatable            
                  parentCallback={handleCallback}    
                  modal={showArticleModalWithDatatable}                                
                />
      </>
    );
  };

 export default BomModal;